export default "__VITE_ASSET__CIRFa4Oe__"